import React, { useCallback, useRef, useState } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
// --- Import Functions
import pixelEvent from "../../hooks/pixelEvent";
// --- Import Components
import Portal from "../UI/Portal/Portal";
// --- Import Styles
import "./PaymentFrame.sass";

/**
 * If you can`t run it on localhost
 * Win+R > past  chrome.exe  --disable-site-isolation-trials --disable-web-security --user-data-dir="C:\temp" > Enter
 */

const domain = process.env.NODE_ENV === "development" ? "http://pcapp.loc" : "";

function PaymentFrame({
  userData,
  frameIsOpen,
  closeFrame,
  typeForm,
  oid,
  licId,
  prodTitle,
  licPeriod,
  amount,
  prodKey,
  priceType,
  thankYou,
}) {
  const { guid } = userData;

  const [currentPage, setCurrentPage] = useState();

  const iframe = useRef();
  const closeBtn = useRef();

  const closeFunc = useCallback(() => {
    if (currentPage.indexOf("p=u1") > 0 || currentPage.indexOf("&up=1") > 0) {
      iframe.current.src = `${domain}/fa/activated_lic.php?guid=${guid}&f=${typeForm}`;
    } else if (currentPage.indexOf("important") > 0) {
      iframe.current.src = `${domain}/fa/activated_lic.php?guid=${guid}&f=${typeForm}&i=1`;
    } else {
      closeFrame();
      pixelEvent({
        evt_src: "acct",
        evt_action: "click_close",
        guid,
      });
    }
  }, [currentPage]);

  function iframeOnLoad(e) {
    const iframeWindow = e.target.contentWindow;
    const iframeLink = iframeWindow.document.location.href;
    setCurrentPage(iframeLink);

    if (iframeLink.indexOf(`${domain}/account`) > 0) {
      document.location.href = `${domain}/notify_click_v2.php?guid=${guid}`;
    }

    function getCloseBtnClass() {
      let res = "payment-modal__close--white";
      if (
        iframeLink.indexOf("important") > 0 ||
        iframeLink.indexOf("activated_lic") > 0
      ) {
        res = "payment-modal__close--transparent";
      } else if (iframeLink.indexOf("lic_notice") > 0) {
        res = "payment-modal__close--hide";
      } else if (iframeLink.indexOf("form_c") > 0) {
        res = "payment-modal__close--black";
      }
      return res;
    }
    closeBtn.current.classList.add(getCloseBtnClass());
  }

  const iframeSrc = `${domain}/?p=lpd_cc_form_${typeForm}&guid=${guid}&oid=${oid}&licId=${licId}&t=${prodTitle}&l=${licPeriod}&a=${amount}&pk=${prodKey}&pt=${encodeURI(
    priceType
  )}&th=${encodeURIComponent(thankYou)}`;
  return (
    frameIsOpen && (
      <Portal>
        <div className="payment-modal">
          <div className="payment-modal__frame">
            <iframe
              className="payment-modal__content"
              title="Payment frame"
              ref={iframe}
              src={iframeSrc}
              onLoad={iframeOnLoad}
            />
            <button
              ref={closeBtn}
              onClick={closeFunc}
              className="payment-modal__close"
            >
              close
            </button>
          </div>
        </div>
      </Portal>
    )
  );
}

const mapStateToProps = (state) => ({
  userData: state.userDataStore.userData,
});

const mapDispatchToProps = {};

PaymentFrame.propTypes = {
  userData: PropTypes.objectOf(PropTypes.string).isRequired,
  frameIsOpen: PropTypes.bool,
  closeFrame: PropTypes.func.isRequired,
  typeForm: PropTypes.string,
  oid: PropTypes.number.isRequired,
  licId: PropTypes.number.isRequired,
  prodTitle: PropTypes.string.isRequired,
  licPeriod: PropTypes.string.isRequired,
  amount: PropTypes.string.isRequired,
  prodKey: PropTypes.string.isRequired,
  priceType: PropTypes.string.isRequired,
  thankYou: PropTypes.string.isRequired,
};
PaymentFrame.defaultProps = {
  frameIsOpen: false,
  typeForm: "b",
};
export default connect(mapStateToProps, mapDispatchToProps)(PaymentFrame);
